import { useEffect, useState } from "react";
import { Button, ErrorText, Stack, SuccessText, TextField } from "components";
import { useKeyPressListener } from "hooks";
import { useClaimVoucherMutation, useGetUserQuery } from "features/api";
import { CLAIM_VOUCHER_ERRORS } from "./constants";

const ClaimVoucherForm = () => {
  const [code, setCode] = useState("");
  const { data: user } = useGetUserQuery(undefined);
  const [claim, claimData] = useClaimVoucherMutation();
  const { isLoading, error: claimError, isSuccess } = claimData;
  const error = (claimError as any)?.data?.m;

  const handleClaim = () => {
    if (code && user) {
      claim({ code, id: user.id });
    }
  };

  useKeyPressListener("Enter", handleClaim);

  useEffect(() => {
    if (isSuccess) {
      setCode("");
    }
  }, [isSuccess]);

  return (
    <Stack direction="column">
      <Stack>
        <TextField
          value={code}
          onChange={(e) => setCode(e.target.value)}
          iconStart="confirmation_number"
          placeholder="Enter voucher code"
        />
        <Button
          filled
          onClick={handleClaim}
          disabled={Boolean(isLoading || !code)}
        >
          Claim
        </Button>
      </Stack>
      {isSuccess && <SuccessText>Voucher is claimed successfully</SuccessText>}
      {error && <ErrorText>{CLAIM_VOUCHER_ERRORS[error] || error}</ErrorText>}
    </Stack>
  );
};

export default ClaimVoucherForm;
